/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_INTEREST_RECIEVED_REPORT = 'GET_INTEREST_RECIEVED_REPORT';
export const SET_SELECTED_INPUT_RECIEVED = 'SET_SELECTED_INPUT_RECIEVED';
export const IS_LOADING = 'IS_LOADING';
export const REFRESH_INTEREST_RECIEVED = 'REFRESH_INTEREST_RECIEVED';
export const SEARCH_SCREEN_REDUX_DATA = 'SEARCH_SCREEN_REDUX_DATA';
